import { memo } from 'react';
import { useTranslation } from '@bonanza-social/i18n';
import { useSelector } from '@bonanza-social/toolkit/state';
import { Box, Text, Button, Timer } from '@bonanza-social/moonlight';
import {
  selectPrizeWallState,
  selectPrizeWallOpenDate,
  selectPrizeWallCostOfPlay,
} from '../../state/prizeWall/prizeWall.slice';
import { PrizeWallButtonProps } from './PrizeWallButton.types';
import PrizeWallTokenIcon from '../PrizeWallTokenIcon/PrizeWallTokenIcon';

function PrizeWallButton({ disabled, onPress }: PrizeWallButtonProps) {
  const [t] = useTranslation('prizeWall');
  const state = useSelector(selectPrizeWallState);
  const openDate = useSelector(selectPrizeWallOpenDate);
  const costOfPlay = useSelector(selectPrizeWallCostOfPlay);

  return (
    <Button disabled={disabled} onPress={disabled ? undefined : onPress}>
      <Box flexDirection="row" alignItems="center">
        {state === 'Pending' ? (
          <>
            <Text variant="body-s-semi" color="accentSurfaceDisabled">
              {t('prizeWallOpenInfo')}
            </Text>
            {openDate && <Timer variant="body-s-semi" time={openDate} />}
          </>
        ) : (
          <>
            <Text variant="body-s-semi" color="accentSurfacePrimary">
              {t(`prizeWallButton`, {
                amount: costOfPlay,
                context: state?.toLowerCase(),
              })}
            </Text>
            <PrizeWallTokenIcon
              marginLeft="space-100"
              width="space-500"
              height="space-500"
            />
          </>
        )}
      </Box>
    </Button>
  );
}

export default memo(PrizeWallButton);
